export const ADJACENT_COURSE_PAUSE_REQUEST_TYPE = {
  previous: 'previous',
  next: 'next',
};
